import Vue from 'vue'
import Router from 'vue-router'
import WebLayout from '../components/WebLayout'
import Paytable from '../components/PaytableGame.vue'
import RuleGame from '../components/RuleGame.vue'
import ResultGame from '../components/ResultGame.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      name: 'web-layout',
      path: '*',
      component: WebLayout,
      children: [
        {
          name: 'paytable-game',
          path: '/paytable',
          component: Paytable,
        },
        {
          name: 'rulegame',
          path: '/rule',
          component: RuleGame,
        },
        {
          name: 'result-game',
          path: '/result',
          component: ResultGame,
        },
      ]
    },
  ],
})

export default router
